<script>
import { cloneDeep } from "lodash";
import WarehouseArea from "@/router/views/property/settings-template/warehouse-component/area-modal.vue";

export default {
  name: "PropertyWarehouseModal",
  components: {
    WarehouseArea,
  },
  data() {
    return {
      tableData: [],
      modalTitle: "",
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: "",
      filterLocation: "",
      sortDesc: false,
      fields: [
        {
          key: "buildingName",
          sortable: true,
        },
        {
          key: "buildingLocation",
          thStyle: { width: "200px" },
          sortable: true,
        },
        {
          key: "buildingDescription",
          thStyle: { width: "200px" },
          sortable: true,
        },
      ],
      fieldsLocation: [
        {
          key: "location",
          sortable: true,
        },
        {
          key: "locationCode",
          thStyle: { width: "200px" },
          sortable: true,
        },
        {
          key: "floorNumber",
          thStyle: { width: "130px" },
        },
        {
          key: "roomNumber",
          thStyle: { width: "130px" },
        },
      ],
      locations: null,
      area: null,
      carouselPage: 0,
      campus: "",
      campusSelected: this.$store.state.data.selectedCampus.id,
      campusOptions: this.$store.state.decrypt.campusAccessList(),
      tableBusy: false,
    };
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (
            item.buildingName.toUpperCase().includes(this.filter.toUpperCase())
          ) {
            return item.buildingName
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          } else if (
            item.buildingLocation
              .toUpperCase()
              .includes(this.filter.toUpperCase())
          ) {
            return item.buildingLocation
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          } else if (
            item.buildingDescription
              .toUpperCase()
              .includes(this.filter.toUpperCase())
          ) {
            return item.buildingDescription
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          }
        });
      }
      return data;
    },
    paginated() {
      let data = this.filtered;
      var total = this.currentPage * this.perPage;
      var currentData = data.slice(total - this.perPage, total);
      if (this.currentPage > 1 && currentData.length == 0) {
        total = (this.currentPage - 1) * this.perPage;
        currentData = data.slice(total - this.perPage, total);
      }
      return currentData;
    },
    rows() {
      if (this.filter.trim() != "" && this.filter) {
        return this.filtered.length;
      } else {
        return this.tableData.length;
      }
    },

    filteredLocation() {
      let data = this.locations.locations;
      if (this.filterLocation.trim() != "" && this.filterLocation) {
        data = data.filter((item) => {
          if (
            item.location
              .toUpperCase()
              .includes(this.filterLocation.toUpperCase())
          ) {
            return item.location
              .toUpperCase()
              .includes(this.filterLocation.toUpperCase());
          } else if (
            item.locationCode
              .toUpperCase()
              .includes(this.filterLocation.toUpperCase())
          ) {
            return item.locationCode
              .toUpperCase()
              .includes(this.filterLocation.toUpperCase());
          }
        });
      }
      return data;
    },
    paginatedLocation() {
      let data = this.filteredLocation;
      var total = this.locations.currentPage * this.locations.perPage;
      var currentData = data.slice(total - this.locations.perPage, total);
      if (this.locations.currentPage > 1 && currentData.length == 0) {
        total = (this.locations.currentPage - 1) * this.locations.perPage;
        currentData = data.slice(total - this.locations.perPage, total);
      }
      return currentData;
    },
    rowsLocation() {
      if (this.filterLocation.trim() != "" && this.filterLocation) {
        return this.filteredLocation.length;
      } else {
        return this.locations.locations.length;
      }
    },
  },
  methods: {
    getData(campusId) {
      this.carouselPage = 0;
      this.currentPage = 1;
      this.tableBusy = true;
      this.campusSelected = campusId;
      this.$store
        .dispatch("propertywarehouse/GetWarehouseBuilding", campusId)
        .then((res) => {
          this.tableBusy = false;
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          res.data.forEach((item) => {
            item.currentPage = 1;
            item.perPage = 10;
            item.tableBusy = false;
            item.locations = null;
          });
          this.tableData = res.data;
        })
        .catch(() => {
          this.tableBusy = false;
          return this.showToast(
            "Something went wrong - getting location list!",
            "error"
          );
        });
    },
    getLocation() {
      this.locations.tableBusy = true;
      this.locations.currentPage = 1;
      this.locations.perPage = 10;
      this.filterLocation = "";
      this.locations.locations = [];
      this.$store
        .dispatch("propertywarehouse/GetWarehouseLocation", this.locations.id)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.locations.locations = res.data;
          this.locations.tableBusy = false;
        })
        .catch(() => {
          this.locations.tableBusy = false;
          return this.showToast(
            "Something went wrong - getting location list!",
            "error"
          );
        });
    },
    getArea() {
      this.area.tableBusy = true;
      this.area.areas = [];
      this.$store
        .dispatch("propertywarehouse/GetLocationAreaByLocation", this.area.location.id)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.area.areas = res.data;
          this.area.tableBusy = false;
        })
        .catch(() => {
          this.area.tableBusy = false;
          return this.showToast(
            "Something went wrong - getting location list!",
            "error"
          );
        });
    },
    goToBuilding() {
      this.carouselPage = 0;
      this.location = null;
      this.area = null;
    },
    goToLocation(row) {
      if (row) {
        this.locations = cloneDeep(row);
        this.getLocation();
      }
      this.carouselPage = 1;
      this.area = null;
    },
    goToWarehouse(row) {
      if (row) {
        this.area = {
          location: cloneDeep(row),
          areas: [],
          tableBusy: false,
        }
        this.getArea();
      }
      this.carouselPage = 2;
    },
    dropData(data) {
      this.$emit("dropData", data);
      this.goToBuilding();
      this.$bvModal.hide("warehouse-modal");
    },
  },
};
</script>

<template>
  <b-modal
    id="warehouse-modal"
    title="Location List"
    size="xl"
    title-class="font-18"
    hide-footer
  >
    <div v-if="carouselPage == 0">
      <div class="row mb-2 mt-1">
        <div class="col-3">
          <div class="d-flex align-items-center h-100">
            <h5 class="mb-0">Building List</h5>
          </div>
        </div>
        <div class="col-9">
          <label class="d-flex align-items-center">
            <b-form-select
              id="campusSelect"
              class="form-select"
              v-model="campusSelected"
              size="sm"
              @change="getData(campusSelected)"
            >
              <option v-for="x in campusOptions" :key="x.Id" :value="x.Id">
                {{ x.CampusName }}
              </option>
            </b-form-select>
            <b-form-input
              autocomplete="off"
              v-model="filter"
              type="search"
              placeholder="Search building..."
              class="form-control mx-2 w-75"
            ></b-form-input>
            <b-form-select
              class="form-select w-25"
              v-model="perPage"
              :options="pageOptions"
            ></b-form-select>
          </label>
        </div>
      </div>
      <div>
        <b-card-header v-if="tableBusy">
          <div class="d-flex justify-content-center align-items-center">
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-20px h-20px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <strong>Loading...</strong>
          </div>
        </b-card-header>
        <b-card-header v-else-if="paginated.length == 0">
          <div class="text-center">
            <div v-if="filter != ''">
              <i class="fas fa-exclamation-triangle me-2"></i>There are no buildings matching your request
            </div>
            <div v-else>
              <i class="fas fa-exclamation-triangle me-2"></i>No
                buildings available
            </div>
          </div>
        </b-card-header>
        <div v-else class="mt-4">
          <div v-for="buildingRow in paginated" :key="buildingRow.id">
            <div>
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <div>{{
                    buildingRow.buildingName
                  }}</div>
                  <small>
                    {{
                      buildingRow.buildingDescription
                    }}
                  </small>
                </div>
                <div class="d-flex align-items-center gap-3">
                  <div style="width: 300px">
                    {{ buildingRow.buildingLocation }}
                  </div>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="font-size-12" style="width: max-content">
                      <a href="javascript: void(0);" class="text-info d-flex align-items-center"
                        @click="goToLocation(buildingRow)">
                        View Locations
                        <i class="bx bx-chevron-right rotate font-size-14"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
            </div>
          </div>
        </div>
        <div class="row pt-3 pb-3">
          <div v-if="rows > 0" class="col">
            Showing {{ (currentPage - 1) * perPage + 1 }} -
            {{
              rows > (currentPage - 1) * perPage + perPage
                ? (currentPage - 1) * perPage + perPage
                : rows
            }}
            of {{ rows }}
          </div>
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="paginate pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="carouselPage == 1 && locations">
      <div class="row mt-1 mb-3">
        <div class="col-sm-12 col-md-6">
          <div class="d-flex align-items-center h-100">
            <a
              href="javascript:void(0);"
              class="d-flex align-items-center"
              @click="goToBuilding()"
              ><i class="bx bx-left-arrow-alt fs-2 me-1"></i>
              <h5 class="m-0">Location List</h5></a
            >
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <label class="d-flex align-items-center">
            <b-form-input
              autocomplete="off"
              v-model="filterLocation"
              type="search"
              placeholder="Search location..."
              class="form-control mx-2 w-75"
            ></b-form-input>
            <b-form-select
              class="form-select w-25"
              v-model="locations.perPage"
              :options="pageOptions"
            ></b-form-select>
          </label>
        </div>
      </div>
      <div>
        <b-card-header v-if="locations.tableBusy">
          <div class="d-flex justify-content-center align-items-center">
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-20px h-20px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <strong>Loading...</strong>
          </div>
        </b-card-header>
        <b-card-header v-else-if="paginatedLocation.length == 0">
          <div class="text-center">
            <div v-if="filterLocation != ''">
              <i class="fas fa-exclamation-triangle me-2"></i>There are no buildings matching your request
            </div>
            <div v-else>
              <i class="fas fa-exclamation-triangle me-2"></i>No
                buildings available
            </div>
          </div>
        </b-card-header>
        <div v-else class="mt-4">
          <div v-for="locationRow in paginatedLocation" :key="locationRow.id">
            <div>
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <div>{{
                    locationRow.location
                  }}</div>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <div style="width: 180px">
                    Location Code: {{ locationRow.locationCode }}
                  </div>
                  <div style="width: 180px">
                    Floor Number: {{ locationRow.floorNumber }}
                  </div>
                  <div style="width: 180px">
                    Room Number: {{ locationRow.roomNumber }}
                  </div>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="font-size-12" style="width: max-content">
                      <a href="javascript: void(0);" class="text-info d-flex align-items-center"
                        @click="goToWarehouse(locationRow)">
                        View Warehouse
                        <i class="bx bx-chevron-right rotate font-size-14"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
            </div>
          </div>
        </div>
        <div class="row pt-3 pb-3">
          <div v-if="rowsLocation > 0" class="col">
            Showing {{ (locations.currentPage - 1) * locations.perPage + 1 }} -
            {{
              rowsLocation > (locations.currentPage - 1) * locations.perPage + locations.perPage
                ? (locations.currentPage - 1) * locations.perPage + locations.perPage
                : rowsLocation
            }}
            of {{ rowsLocation }}
          </div>
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="paginate pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination v-model="locations.currentPage" :total-rows="rowsLocation" :per-page="locations.perPage"></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="carouselPage == 2 && area">
      <div class="row mt-1 mb-3">
        <div class="col-sm-12 col-md-6">
          <div class="d-flex align-items-center h-100">
            <a
              href="javascript:void(0);"
              class="d-flex align-items-center"
              @click="goToLocation()"
              ><i class="bx bx-left-arrow-alt fs-2 me-1"></i>
              <h5 class="m-0">Warehouse</h5></a
            >
          </div>
        </div>
      </div>
        <div class="custom-table-responsive mb-0 mt-2">
          <b-card-header v-if="area.tableBusy">
            <div class="d-flex justify-content-center align-items-center">
              <div class="preloader-component me-2">
                <div class="status">
                  <div class="spinner-chase w-20px h-20px">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
              <strong>Loading...</strong>
            </div>
          </b-card-header>
          <b-card-header v-else-if="!area || area.areas.length == 0">
            <div class="text-center">
              <i class="fas fa-exclamation-triangle me-2"></i>No
                warehouse locations available
            </div>
          </b-card-header>
          <div v-for="areaRow in area.areas" :key="areaRow.id">
            <warehouse-area ref="warehouseArea" :areaRow="areaRow" @dropData="dropData($event)"></warehouse-area>
          </div>
        </div>
    </div>
  </b-modal>
</template>